import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Use Type List with Query (for remote operations)
export const getWaterUseTypeListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_USE_TYPES}?${stringifyParams(
			params
		)}`
	);
};

// Get Water Use Type List with Query
export const getWaterUseTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_USE_TYPES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Water Use Type
export const getWaterUseType = water_use_type_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_USE_TYPE}${water_use_type_id}`
	);
};

// Add New Water Use Type
export const addNewWaterUseTypeApi = water_use_type => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WATER_USE_TYPE}`,
		water_use_type
	);
};

// Update Water Use Type
export const updateWaterUseTypeApi = water_use_type => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WATER_USE_TYPE}${water_use_type._id}`,
		water_use_type
	);
};

// Delete Water Use Type
export const deleteWaterUseTypeApi = water_use_type_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WATER_USE_TYPE}${water_use_type_id}`
	);
};

// Check if Water Use Type Exists
export const checkWaterUseTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WATER_USE_TYPE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
